export default level => level * 30;
